module.exports = __webpack_public_path__ + "img/icons-upload.05e17f62.svg";